// extracted by mini-css-extract-plugin
module.exports = {"offset":"Content_offset__2RV4r"};